module.exports = __webpack_public_path__ + "static/media/tc.59dec996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tc.png
// module id = 1992
// module chunks = 0